// extracted by mini-css-extract-plugin
export default {"learnMoreLink":"webpack-pages-CitationImports-ImportFromFile-ImportFromFile-module__learnMoreLink"};